import React from 'react';
import {Form, Textarea, List} from 'components';
import {useNamedSelector} from 'helpers';

export function Social() {
  return (
    <Form {...useNamedSelector('clarity.form', { name: 'social' })}>
      <List tiny-gutter>
        <List.Title>What are you longing for in regards to your family and friends?</List.Title>
        <Textarea single name="1" />
        <List.Title>What does family represent for you?</List.Title>
        <Textarea single name="2" />
        <List.Title>What is missing in your social life?</List.Title>
        <Textarea single name="3" />
        <List.Title>What kind of parent/sibling/child do you want to be?</List.Title>
        <Textarea single name="4" />
        <List.Title>What is the best quality you bring to your family and friendships?</List.Title>
        <Textarea single name="5" />
        <List.Title>What is your role in your family and with friends (e.g. caretaker, instigator, comedian, etc.) How do you feel in that role?</List.Title>
        <Textarea single name="6" />
        <List.Title>Where do you hold back with your family and/or friends?</List.Title>
        <Textarea single name="7" />
        <List.Title>What is your most common excuse for not spending time with the people that are most important to you?</List.Title>
        <Textarea single name="8" />
      </List>
    </Form>
  );
}
